import React, { Component } from 'react'
import bbox from 'geojson-bbox'
import union from '@turf/union'
import GoogleMap from 'common/views/components/GoogleMap'
import styled from 'styled-components'

import SLDefaultMap from 'broker/views/components/SkeletonLoader/SLDefaultMap'

const MapBox = styled.div`
  height: ${ props => props.height || '200px'};
  width: ${ props => props.width || '400px'};
  margin: 0;
`

export default class SCMapBox extends Component {
    constructor(props) {
      super(props)
    }

    reduceIfGeometryCollection = (a) => {
      if (a.type === 'GeometryCollection') {
        const geometries = _.filter(a.geometries, g => {
          return !_.includes(['MultiPoint', 'Point'], g.type)
        })
        return geometries.reduce(union)
      }
      return a
    }

    shouldComponentUpdate(nextProps) {
      return nextProps.geo_json !== this.props.geo_json
    }

    render() {
      let geo_json;
      if (this.props.geo_json) {

        //Depending on the formatting passed in we may need to double parse the object
        if (Array.isArray(this.props.geo_json)) {
          geo_json = this.props.geo_json.map((geo) => (JSON.parse(JSON.parse(geo))))
        } else {
          geo_json = this.props.geo_json
        }

        if (geo_json.length > 1) {
          let geo_json_reduced = null
          var index;
          for (index = 0; index < geo_json.length; index++) {
            geo_json_reduced = geo_json_reduced ? union(geo_json_reduced, this.reduceIfGeometryCollection(geo_json[index])) : this.reduceIfGeometryCollection(geo_json[index])
          }
          geo_json = geo_json_reduced.geometry
        } else if (Array.isArray(this.props.geo_json)) {
            geo_json = geo_json[0]
        }

        if (geo_json) {
          let bounds = bbox(geo_json)
          this.normalizedBounds = [
            [bounds[1], bounds[0]],
            [bounds[3], bounds[2]]
          ]
        }
      }

      if (this.normalizedBounds && geo_json) {
        return (
          <MapBox className={'google-map'} height={this.props.height} width={this.props.width}>
            <GoogleMap bounds={this.normalizedBounds} geoJsonData={geo_json} dispatch={this.props.dispatch}/>
          </MapBox>
        )
      }

      return (
        <MapBox className={'google-map'} height={this.props.height} width={this.props.width}>
          <SLDefaultMap/>
        </MapBox>
      )
    }
  }
